<template>
  <custom-dialog :title="model.title" width="1000px" :visible="visible" v-on="$listeners" class="tim-record-dialog" :append-to-body="true">
    <div class="dialog-body">
      <div class="table-bd">
        <custom-table height="100%" :index="true" :data="tableList" tableCode="protocol_tim_record" @sort="sortChange" @filter="filterChange" :slots="['action']">
          <template v-slot:action="scope">
            <span>
              <el-button type="text" size="mini" @click="onDel(scope.row)">{{ $t('Common.com_delete') }}</el-button>
              <el-button type="text" size="mini" @click="onDetail(scope.row)">{{ $t('Common.com_detail') }}</el-button>
            </span>
          </template>
        </custom-table>
      </div>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  name: 'timRecordDialog',
  mixins: [dialogMixins],
  components: {},
  props: {},
  data() {
    return {
      formSearch: {
        keyword: '',
        orderType: '',
        orderBy: '',
        pageSize: 20,
        pageNum: 1,
      },
      tableList: [],
      totalRows: null,
      xmlPreviewVisible: false,
      xmlPreviewModel: {},
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    closeDialog() {
      this.visible = false;
    },
    getTableList() {
      const protocolId = this.model.data.protocolId;
      // publishType 发布类型，1-TCP，2-TIM，3-TMM'
      this.$getJSON(`${apis.ProtocolPublishList}/${protocolId}`, {
        publishType: '2',
      }).then((res) => {
        this.tableList = res.data;
      });
    },
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    onDel(row) {
      this.$showConfirm(this.$t('dms_tim_record_dialog.nqdyscxzdsjm')).then(() => {
        this.$postJSON(`${apis.ProtocolPublishPublishDelete}/${row.publishId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },
    onDetail(row) {
      const publishId = row.publishId;
      const bizType = 'tim';
      this.$getFileList({ bizId: publishId, bizType }).then((data) => {
        if (data && data.length) {
          const item = data[0];
          window.open(this.getAttachUrl(item));
        } else {
          this.$message({
            message: this.$t('dms_tim_record_dialog.cha_wu_shu_ju'),
            type: 'warning',
          });
        }
      });
    },
  },
  created() {},
  mounted() {
    this.getTableList();
  },
};
</script>

<style lang="scss">
.tim-record-dialog {
  .dialog-body {
    height: 500px;
    display: flex;
    flex-direction: column;
  }
}
</style>
